import React from 'react'
import './HeroSection.css'
function HeroSection() {
  return (
<div className='hero-container'>
    <div className='hero-btns'>
        <button><a href="#product">EXPLORE MORE</a></button>
    </div>
    </div>
 )
}

export default HeroSection
